import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");
var QuizCustomization = require("lib/academic/QuizCustomization");

var DropDownOptions = require("components/utility/DropDownOptions");
var Glyphicon = require("components/utility/icons/Glyphicon");

var RosterActions = require("lib/actions/RosterActions");

@connect(
	(state, props) => {
		return {"premiumAccount": CurrentUser.isPremiumAccount()}
	},

	(dispatch, props) => ({
		
		onChange: (update) => {
			return dispatch( RosterActions.updateAdminPrefs({
				id: CurrentUser.get().id,
				update: update
			}))	
		},
	})
)
class OnboardingStageCustomizeQuiz extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("OnboardingStageCustomizeQuiz");
		this.initState(props)
	}

	initState(props) {
		var selectedComposition = props.premiumAccount ? MIXED_QUIZ : MEDIUM
		this.state = {
			selectedComposition: selectedComposition,
			selectedFrequency: "month", 
			selectedQuizCount: 1,
			questionsCount: 1,
			frequencyStarts: [1]
		}
	}

	useSentenceStarters() {
		var gradeLevel = parseInt(CurrentUser.get().grade_level)
		if (Number.isNaN(gradeLevel)) {
			gradeLevel = 1
		}

		return gradeLevel < 5;
	}

	getCurrentComposition() {
		if (this.props.premiumAccount){
			var options = OPTIONS
		} else {
			var options = FREE_OPTIONS
		}
		var base = _.clone(options[this.state.selectedComposition]);

		if (this.useSentenceStarters()) {
			// K-4th start with sentence starters
			base.starter_count = base.open_count;
			base.open_count = 0;
		}

		return base;
	}


	getQuizMetrics(prefs) {
		if (prefs && prefs.expectations_metrics) {
			var hasMetric = false;
			var newMetrics = _.map(prefs.expectations_metrics, (metric) => {
				if (metric.metric == "quizzes-passed") {
					metric.goal = parseInt(this.state.selectedQuizCount);
				} else if (metric.metric == "questions") {
					// Also use this amount for practice question default 
					metric.goal = parseInt(this.state.questionsCount);
				}
				return metric;
			})
		} else {
			var newMetrics = [{
				metric:"quizzes-passed", goal: parseInt(this.state.selectedQuizCount)
			}]
		}
		return newMetrics
	}

	createGradeLevelPrefHash(){
		var settings = this.getCurrentComposition()
		var grade_level_expectations_metrics = {}
		var grade_level_question_count = {}
		var settings = this.getCurrentComposition()
		ALL_GRADES.map((gl)=>{
			grade_level_expectations_metrics[gl] = [
				{metric: "quizzes-passed", "goal": parseInt(this.state.selectedQuizCount)},
				{metric: "questions", goal: 3}
			]
			grade_level_question_count[gl] = {
				recall_question_count: parseInt(settings.fitb_count),
				analysis_question_count: parseInt(settings.open_count),
				sentence_starter_count: parseInt(settings.starter_count),
			}
		})

		return {
			expectations_time_period: this.state.selectedFrequency,
			expectations_time_period_starts: this.state.frequencyStarts,
			grade_level_expectations_metrics: grade_level_expectations_metrics,
			grade_level_question_count: grade_level_question_count,
			speech_controls: settings.speech_controls
		}		
	}
	submitSettings() {
		var settingsData = this.createGradeLevelPrefHash()
		this.props.onChange(settingsData);
		this.props.onComplete()
		Mycroft.newEvent({ category: "Onboarding", action: "quiz-customized" });
		Mycroft.newEvent({ category: "Mode", action: "selected-questions-amount" });
	}

	skipToNextStage() {
		this.props.onComplete();
		Mycroft.newEvent({ category: "Onboarding", action: "skipped-quiz-customization" });
	}

	////////// QUIZ FREQUENCY
	onQuizCountChange() {
		var value = this.refs.quiz_count.value 
		this.setState({selectedQuizCount: value})
	}

	onQuestionsCount() {
		var value = this.refs.questions_count.value 
		this.setState({questionsCount: value })
	}


	setQuizComposition(val) {
		this.setState({ selectedComposition: val });
	}

	onExpectationPeriod() {
		var timePeriod = this.refs.expectation_period.value
		if (timePeriod == $wr.Constants.PERIODS.WEEK) {
			var defaultPeriodStart = [0];
		} else if (timePeriod == $wr.Constants.PERIODS.MONTH) {
			var defaultPeriodStart = [1];
		} else {
			var startMonth = CurrentUser.get().prefs.school_year_start_month;
			var currentYear = (new Date()).getFullYear();
			var defaultPeriodStart = [$wr.formatDate(new Date(currentYear, startMonth), "YYYY-MM-DD")];

			if (timePeriod == $wr.Constants.PERIODS.QUARTER) {
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 3), "YYYY-MM-DD"));
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 6), "YYYY-MM-DD"));
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 9), "YYYY-MM-DD"));
			} else if (timePeriod == $wr.Constants.PERIODS.TRIMESTER) {
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 4), "YYYY-MM-DD"));
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 8), "YYYY-MM-DD"));
			} else if (timePeriod == $wr.Constants.PERIODS.SEMESTER) {
				defaultPeriodStart.push($wr.formatDate(new Date(currentYear, startMonth + 6), "YYYY-MM-DD"));
			}
		} 
		this.setState({selectedFrequency: timePeriod, frequencyStarts: defaultPeriodStart})
	}
	renderFrequencyOption() {
		var options = []
		for (var i=1;i<21;i++){
			options.push(
				<option value={ i } key={ i }>{ i }</option>
			)
		}
		if (this.props.persistentData.literacy_intention) {
			var bookNoun = $wr.pluralize("book", this.state.selectedQuizCount, "books");
			var quizzesDropdown = (
				<div>
					<select type="text" className="form-control quizCount" ref="quiz_count"
						defaultValue={ 1 } onChange={this.onQuizCountChange}>
						{ options }
					</select>
					<p>
						{ bookNoun }
					</p>
				</div>
			)
			var title = (
				<p className="categoryTitle">
					While students are reading books, they will practice standard-aligned literacy skills by 
					responding to questions that deepen their text engagement.
				</p>
			)
			var questionNoun = $wr.pluralize("question", this.state.questionsCount, "questions");
			var questionsDropdown = (
				<div className="questionsContainer">
					<p className="questionsText">How many questions will your students answer?</p>
					<select type="text" className="form-control quizCount" ref="questions_count"
						defaultValue={ 1 } onChange={ this.onQuestionsCount }>
						{ options }
					</select>
					<p>
						{ questionNoun }
					</p>
				</div>
			)
			var text = <p>How many books will your students read (quizzes completed)?</p>
			var frequency = (
				<div className="frequencyContainer">
					<p className="frequencyText">How often will your students read books and answer questions?</p>
					<p>{ this.state.selectedQuizCount } { bookNoun } { this.state.questionsCount } { questionNoun } per </p>
					<select type="text" className="form-control quizFrenquency" ref="expectation_period"
						value={ this.state.selectedFrequency } onChange={ this.onExpectationPeriod }>
						{ DropDownOptions.Select.ExpectationPeriods({ filter: [$wr.Constants.PERIODS.ALLTIME] }) }
					</select>
				</div>
			)
		} else {
			var noun = $wr.pluralize("quiz", this.state.selectedQuizCount, "quizzes");
			var quizzesDropdown = (
				<div>
					<select type="text" className="form-control quizCount" ref="quiz_count"
						defaultValue={ 1 } onChange={this.onQuizCountChange}>
						{ options }
					</select>
					<p>
						{ noun } per
					</p>
					<select type="text" className="form-control quizFrenquency" ref="expectation_period"
						value={ this.state.selectedFrequency } onChange={ this.onExpectationPeriod }>
						{ DropDownOptions.Select.ExpectationPeriods({ filter: [$wr.Constants.PERIODS.ALLTIME] }) }
					</select>
				</div>
			)
			var title = (
				<p className="categoryTitle">
					After your students read books, they take quizzes about them on Whooo's Reading. 
					How often do you want your students to take quizzes?
				</p>
			)
		}
		return (
			<div className="settingContainer">
				{ title }
				<div className="selectContainer">
					{ text }
					{ quizzesDropdown }
					{ questionsDropdown }
					{ frequency }
				</div>
			</div>
		)
	}

	renderPremiumCompositionSection(){
		var options = _.map(OPTIONS, (option, optionKey) => {
			var className = "largeObject clickableElement";
			if (this.state.selectedComposition == optionKey) {
				className += " selected";
			}

			var duration = QuizCustomization.quizDuration(
				option.fitb_count, option.open_count || option.starter_count,
				this.useSentenceStarters()
			);

			var parts = []
			if (option.fitb_count) {
				parts.push(option.fitb_count + " fill-in-the-blank")
			}
			if (option.open_count || option.starter_count) {
				parts.push((option.open_count || option.starter_count) + " open")
			}
			var compText = parts.join(", ")

			return (
				<div key={optionKey} className={ className }
					onClick={ this.setQuizComposition.bind(this, optionKey) }>

					<div className="opTitle">{ option.title }</div>
					<div className="comp">{ compText }</div>
					<div className="time">{ duration } minutes</div>
				</div>
			)
		})
		return (
			<div className="settingContainer">
				<p className="categoryTitle">
					Quizzes have a mix of "fill-in-the-blank" and "open-ended" questions.
					What balance do you want?
				</p>
				<div className="options">
					{ options }
				</div>
				{ this.renderTextVarietyImgs() }
			</div>
		);
	}

	renderFreeCompositionSection() {
		var options = _.map(FREE_OPTIONS, (option, optionKey) => {
			var className = "largeObject clickableElement";
			if (this.state.selectedComposition == optionKey) {
				className += " selected";
			}

			var duration = QuizCustomization.quizDuration(
				option.fitb_count, option.open_count || option.starter_count,
				this.useSentenceStarters()
			);

			var parts = []
			if (option.open_count || option.starter_count) {
				parts.push((option.open_count || option.starter_count) + " open")
			}
			var compText = parts.join(", ")

			return (
				<div key={optionKey} className={ className }
					onClick={ this.setQuizComposition.bind(this, optionKey) }>

					<div className="opTitle">{ option.title }</div>
					<div className="comp">{ compText }</div>
					<div className="time">{ duration } minutes</div>
				</div>
			)
		})
		return (
			<div className="settingContainer">
				<p className="categoryTitle">
					How many Open-Ended Questions do you want on quizzes?
				</p>
				<div className="options">
					{ options }
				</div>
				{ this.renderTextVarietyImgs() }
				<div className='disclaimerContainer'>
					<br></br>
					<i> Fill-in-the-Blank Questions are available through our Gold and Silver plans, or our Silver Trial.</i>
				</div>
			</div>
		);
	}

	////////// QUIZ COMPOSITION
	
	renderCompositionSection() {
		// If the user is a premium account, they should be shown
		// option for FITBs. If not, they should be only shown OEQ count.
		if (this.props.premiumAccount){
			var section = this.renderPremiumCompositionSection()
		} else {
			var section = this.renderFreeCompositionSection()
		}

		return section
	}

	renderTextVarietyImgs() {
		var recallImgPath = "onboarding/onboarding-fill-in-only.png";
		var analysisImgPath = "onboarding/onboarding-short-answer-in-only.png";

		var recallOpacity = 1.0;
		var analysisOpacity = 1.0;
		var recallIcon = "ok";
		var analysisIcon = "ok";

		var settings = this.getCurrentComposition();

		if (!(settings.open_count || settings.starter_count)) {
			analysisOpacity = 0.4;
			analysisIcon = "remove";
		}
		if (!settings.fitb_count) {
			recallOpacity = 0.4;
			recallIcon = "remove";
		}


		return (
			<div className="textVarietyImg">

				<div className="imgContainer row">
					<div className="col-sm-6" style={{opacity:recallOpacity}}>
						<div className="text-center description">
							<Glyphicon icon={ recallIcon } /> Fill-in-the-Blank Question
						</div>
						<img src={ dynamicRequire(recallImgPath) } className="formatImg" />
					</div>
					<div className="col-sm-6" style={{opacity:analysisOpacity}}>
						<div className="text-center description">
							<Glyphicon icon={ analysisIcon } /> Open-Ended Question
						</div>
						<img src={ dynamicRequire(analysisImgPath) } className="formatImg" />
					</div>
				</div>
			</div>
		)
	}

	////////// CONFIRM ACTIONS
	renderSetButton() {
		return (
			<div className="text-right nextStage">
				<button className="btn btn-link setButton"
					onClick={ this.skipToNextStage }>
					Skip
				</button>
				<button className="btn buttonPrimary setButton"
					onClick={ this.submitSettings }>
					Next
				</button>
				<div className="changeLater">You can always change this later.</div>
			</div>
		)
	}

	render() {
		return (
			<div className="onboardingStage onboardingStageCustomizeQuiz clearfix">
				{ this.renderFrequencyOption() }
				{ this.renderCompositionSection() }
				{ this.renderSetButton() }
			</div>
		);
	}
}

var OPEN_QUIZ = "2-open-only";
var MIXED_QUIZ = "3-mixed";
var ADVANCED_QUIZ = "4-advanced";

var OPTIONS = {
	[OPEN_QUIZ]: {
		title: "Open-ended only",
		fitb_count: 0,
		open_count: 2,
		starter_count: 0 // Replaced by open_count based on grade level
	},
	
	[MIXED_QUIZ]: {
		title: "Mixed quiz",
		fitb_count: 2,
		open_count: 1,
		starter_count: 0 // Replaced by open_count based on grade level
	},

	[ADVANCED_QUIZ]: {
		title: "Advanced quiz",
		fitb_count: 3,
		open_count: 2,
		starter_count: 0 // Replaced by open_count based on grade level
	}
}

var SHORT = '1-open'
var MEDIUM = '2-open'
var LONG = '3-open'

var FREE_OPTIONS = {
	[SHORT]: {
		title: "One open ended",
		fitb_count: 0,
		open_count: 1,
		starter_count: 0 // Replaced by open_count based on grade level
	},
	[MEDIUM]: {
		title: "Two open ended",
		fitb_count: 0,
		open_count: 2,
		starter_count: 0 // Replaced by open_count based on grade level
	},
	[LONG]: {
		title: "Three open ended",
		fitb_count: 0,
		open_count: 3,
		starter_count: 0 // Replaced by open_count based on grade level
	},
}

var ALL_GRADES = ["-1", "0" ,"1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "Mixed"] 


OnboardingStageCustomizeQuiz.propTypes = StrictPropTypes({
	track: PropTypes.string.isRequired,
	onComplete: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	// only used for the final stage of onboarding
	endOnboarding: PropTypes.func,
	persistentData: PropTypes.object
});

module.exports = OnboardingStageCustomizeQuiz;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/onboarding/OnboardingStageCustomizeQuiz.js